module.exports = __webpack_public_path__ + "static/media/NextSalah.516cc5b0.png";